// Report type constants
export const REPORT_TYPES = {
  DEFAULT: "default",
  EMAGINE: "emagine",
  QTHERAPY: "qtherapy"
};

// Scroll threshold for shadow effect
export const SCROLL_THRESHOLD = 12;

// Iframe IDs
export const IFRAME_IDS = {
  EMAGINE: 'iframe-emagine-report',
  QTHERAPY: 'iframe-qtherapy-report',
  DYNAMIC_CONTENT: 'dynamic-topic-content',
  // Factory function for dynamic topic iframes
  dynamicTopic: (topicId) => `iframe-topic-${topicId}`,
  // Container factory for dynamic topics
  dynamicTopicContainer: (topicId) => `dynamic-topic-container-${topicId}`
};

// Iframe ID utility functions
export const iframeIdManager = {
  /**
   * Get iframe ID for a static report
   * @param {string} reportType - Report type from REPORT_TYPES
   * @returns {string} Iframe ID
   */
  forStaticReport(reportType) {
    return reportType === REPORT_TYPES.QTHERAPY
      ? IFRAME_IDS.QTHERAPY
      : IFRAME_IDS.EMAGINE;
  },

  /**
   * Get iframe ID for a dynamic topic
   * @param {string} topicId - Topic identifier
   * @returns {string} Iframe ID
   */
  forDynamicTopic(topicId) {
    return IFRAME_IDS.dynamicTopic(topicId);
  },

  /**
   * Check if report type is a static report
   * @param {string} reportType - Report type to check
   * @returns {boolean} True if static report
   */
  isStaticReport(reportType) {
    return Object.values(REPORT_TYPES).includes(reportType);
  },

  /**
   * Get the active iframe ID for the selected report
   * @param {string} selectedReport - Currently selected report
   * @returns {string} Active iframe ID
   */
  getActiveIframeId(selectedReport) {
    return this.isStaticReport(selectedReport)
      ? this.forStaticReport(selectedReport)
      : this.forDynamicTopic(selectedReport);
  }
};
